export default __webpack_public_path__ + "static/media/fb_laptop_hover.4f2692b6.png";